export const FF_FRAMING_CONTENT_RELEASE_PAGE = 'framing-content-release-page';
export const FF_FRAMING_GUARANTEE_COPY = 'framing-guarantee-copy';
export const FF_FRAMING_PREVIEWER_PRODUCT_PAGE =
  'framing-previewer-product-page';
export const FF_FRAMING_PREVIEWER_RELEASE_PAGE =
  'framing-previewer-release-page';
export const FF_PRODUCT_SMS_CAPTURE = 'product-sms-capture';
export const FF_PRODUCT_STICKY_CTA_BOTTOM = 'product-sticky-cta-bottom';
